import React, { useState, useEffect } from 'react';
import {
  Container, CssBaseline, ThemeProvider
} from '@mui/material';
import axios from 'axios';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Context
import { AuthProvider, useAuth } from './context/AuthContext';

// Components
import MainPage from './components/MainPage';
import SeriesTable from './components/SeriesTable';
import SpecimenList from './components/SpecimenList';
import AddCoin from './components/AddCoin';
import DenominationPage from './components/DenominationPage';
import Navbar from './components/Navbar';
import SellCoin from './components/SellCoin';
import EditCoin from './components/EditCoin';
import About from './components/About';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';

// Theme
import theme from './theme';

const GOOGLE_CLIENT_ID = '734989916787-qjulab676bnv2akk92rjmn1phipmm72f.apps.googleusercontent.com';

function AppContent() {
  const [coins, setCoins] = useState([]);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      const apiUrl = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001');
      axios.get(`${apiUrl}/coins`)
        .then(res => setCoins(res.data))
        .catch(err => console.error("Error loading coins:", err));
    }
  }, [isAuthenticated]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        {isAuthenticated && <Navbar />}
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
          <Routes>
            <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<MainPage coins={coins} />} />
              <Route path="/denomination/:denom" element={<DenominationPage coins={coins} />} />
              <Route path="/series/:denom/:series" element={<SeriesTable coins={coins} />} />
              <Route path="/coin/:coinId" element={<SpecimenList coins={coins} />} />
              <Route path="/add-coin" element={<AddCoin />} />
              <Route path="/sell-coin" element={<SellCoin />} />
              <Route path="/edit-coin" element={<EditCoin />} />
              <Route path="/edit-coin/:coinId" element={<EditCoin />} />
              <Route path="/about" element={<About />} />
            </Route>
          </Routes>
        </Container>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}